module.exports = {"340123100":"上派镇","340123101":"三河镇","340123103":"官亭镇","340123105":"山南镇","340123106":"花岗镇","340123107":"紫蓬镇","340123108":"桃花镇","340123109":"丰乐镇","340123200":"高店乡","340123201":"铭传乡","340123202":"柿树岗乡","340123203":"严店乡","340123400":"桃花工业园管委会","340123401":"紫蓬山管委会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/340123.json
// module id = 961
// module chunks = 0